import moment from 'moment';

export const getYearsFrom = year => {
  const dateStart = moment({
    year,
    month: 1,
    date: 1
  });
  const dateEnd = moment();
  let availableYears = [];

  while (
    dateEnd > dateStart ||
    dateStart.format('YYYY') === dateEnd.format('YYYY')
  ) {
    availableYears.push(dateStart.format('YYYY'));
    dateStart.add(1, 'years');
  }

  return availableYears.reverse();
};

export const generateYearsFilterArray = ({ first, from }) => {
  let availableYears = getYearsFrom(from).map(year => ({
    text: year,
    value: year
  }));

  if (first) {
    availableYears.unshift(first);
  }

  return availableYears;
};



// WEBPACK FOOTER //
// ./src/utils/date-utils.js